import React from 'react';
import * as AccordionStyles from "./css/KrnAccordion.module.css";

import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion';

const KrnAccordion = () => {
    return (
        <Accordion className={AccordionStyles.accordion}>
            <AccordionItem className={AccordionStyles.accordion__item}>
                <AccordionItemHeading>
                    <AccordionItemButton className={AccordionStyles.accordion__layout}>
                        <p className={AccordionStyles.q}>How do I save and store my current mat workout?</p>
                        <div className={AccordionStyles.accordion__button} />
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel className={AccordionStyles.accordion__panel}>
                    <p className={AccordionStyles.a}>
                        In the “My Workouts” Section you will see all the videos you have downloaded to your personal app. To favorite your current mat exercises, KRN recommends you hit the star button in the top right of the video. To reorder them into your preferred order, first hit the edit button in the top left, followed by the three bars next to each video, and then drag them. Our recommendation is to order them by the foundational mat order. 
                    </p>
                </AccordionItemPanel>
            </AccordionItem>
            <AccordionItem className={AccordionStyles.accordion__item}>
                <AccordionItemHeading>
                    <AccordionItemButton className={AccordionStyles.accordion__layout}>
                        <p className={AccordionStyles.q}>How do I use this for my clients?</p>
                        <div className={AccordionStyles.accordion__button} />
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel className={AccordionStyles.accordion__panel}>
                    <p className={AccordionStyles.a}>
                        If you have identified a thread which is a strength or weakness of your client, you can go into that thread from your home page and specifically look at how to build that type of spinal function for the applicable foundational movements. 
                    </p>
                </AccordionItemPanel>
            </AccordionItem>
            <AccordionItem className={AccordionStyles.accordion__item}>
                <AccordionItemHeading>
                    <AccordionItemButton className={AccordionStyles.accordion__layout}>
                        <p className={AccordionStyles.q}>How to I schedule a workout to give myself reminders?</p>
                        <div className={AccordionStyles.accordion__button} />
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel className={AccordionStyles.accordion__panel}>
                    <p className={AccordionStyles.a}>
                        When you first click on the video for any movement, you will see its landing page with the recommended repetitions and if you should omit or adjust it for a client issue. From this screen, click the calendar in the top left and schedule the workout. If you have given the app access to your phone calendar, the calendar app will send you a notification. Your home page will also show any upcoming workouts.
                    </p>
                </AccordionItemPanel>
            </AccordionItem>
            <AccordionItem className={AccordionStyles.accordion__item}>
                <AccordionItemHeading>
                    <AccordionItemButton className={AccordionStyles.accordion__layout}>
                        <p className={AccordionStyles.q}>How do I assign a client homework using this app?</p>
                        <div className={AccordionStyles.accordion__button} />
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel className={AccordionStyles.accordion__panel}>
                    <p className={AccordionStyles.a}>
                        You’ll have to have the client download the app and walk them through the foundational exercise section so they can orient themselves in the method and know what to download, favorite, and how to order the movements.
                    </p>
                </AccordionItemPanel>
            </AccordionItem>
            <AccordionItem className={AccordionStyles.accordion__item}>
                <AccordionItemHeading>
                    <AccordionItemButton className={AccordionStyles.accordion__layout}>
                        <p className={AccordionStyles.q}>Why am I seeing the app ask for health data?</p>
                        <div className={AccordionStyles.accordion__button} />
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel className={AccordionStyles.accordion__panel}>
                    <p className={AccordionStyles.a}>
                        If you have downloaded the KRN app on your smartwatch and connected the two, the app will look for that connection when you begin a workout video. If the app is not turned on and connected, it will pop up and prompt you to make the connection. To remove this, remove the app from your watch. The app is designed to see your heart rate as you workout.
                    </p>
                </AccordionItemPanel>
            </AccordionItem>
        </Accordion>
    );
}

export default KrnAccordion;